import {
    actionEffect,
    ListenerMiddleware,
    registerActionEffect,
} from 'store/listenerMiddleware';
import { isAnyOf } from '@reduxjs/toolkit';
import { isResetStateAction } from 'store/rootActions';
import { registerIndexMappingEffects } from 'symbols/indexMappings/store/effects';
import { registerEstimatedTradeCostEffects } from 'widgets/estimatedTradeCost/widget/store/effects';
import { registerEstimatedTradeCostComparisonEffects } from 'widgets/estimatedTradeCost/widget-comparison/store/effects';
import { registerStreamedDataEffects } from 'streamsState/store/streamedData/effects';
import { registerGeneralAppEffects } from 'app/store/general/effects';

export function registerAppEffects(middleware: ListenerMiddleware) {
    registerRootEffects(middleware);
    registerGeneralAppEffects(middleware);
    registerStreamedDataEffects(middleware);
    registerIndexMappingEffects(middleware);
    registerEstimatedTradeCostEffects(middleware);
    registerEstimatedTradeCostComparisonEffects(middleware);
}

export const resetServicesOnResetStateEffect = actionEffect(
    isAnyOf(isResetStateAction),
    async (action, dispatch, state, services) => {
        services.reset();
    }
);

function registerRootEffects(middleware: ListenerMiddleware) {
    registerActionEffect(middleware, resetServicesOnResetStateEffect);
}
